export const STALE_CHUNK_RECOVERY_STORAGE_KEY =
  "fin-lake-front:stale-chunk-recovery";
export const STALE_CHUNK_RECOVERY_ATTEMPTED = "attempted";

interface PreloadFailure {
  preventDefault(): void;
}

/**
 * Reload once for a Vite chunk that disappeared during a rollout. The attempt
 * marker is durable for this tab, so any later preload failure falls through
 * to the normal error boundary instead of entering a reload loop.
 */
export function recoverStaleChunk(
  event: PreloadFailure,
  storage: Pick<Storage, "getItem" | "setItem">,
  location: Pick<Location, "reload">,
): boolean {
  try {
    if (storage.getItem(STALE_CHUNK_RECOVERY_STORAGE_KEY) !== null) {
      return false;
    }
    storage.setItem(
      STALE_CHUNK_RECOVERY_STORAGE_KEY,
      STALE_CHUNK_RECOVERY_ATTEMPTED,
    );
  } catch {
    // Reloading without a durable guard could loop forever. Preserve Vite's
    // original error so the application boundary and Sentry can report it.
    return false;
  }

  event.preventDefault();
  location.reload();
  return true;
}

/** Install the Vite production preload-error boundary before telemetry starts. */
export function installStaleChunkRecovery(browserWindow: Window): void {
  browserWindow.addEventListener("vite:preloadError", (event) => {
    let storage: Storage;
    try {
      storage = browserWindow.sessionStorage;
    } catch {
      return;
    }
    recoverStaleChunk(event, storage, browserWindow.location);
  });
}
